var map = {
	"./en.json": "edd4",
	"./es.acciones.json": "fc92",
	"./es.altaImpago.json": "e690",
	"./es.buscadorGeneral.json": "8a40",
	"./es.cartera.json": "9608",
	"./es.cliente.json": "ee21",
	"./es.consultaFichero.json": "eafa",
	"./es.consultaRealizada.json": "db78",
	"./es.contacto.json": "460c",
	"./es.contrato.json": "52c6",
	"./es.ctiaddress.json": "6501",
	"./es.cuentaYFacturacion.json": "f225",
	"./es.datos.json": "914c",
	"./es.detalleConsulta.json": "d9d6",
	"./es.detalleReclamacion.json": "29a5",
	"./es.documento.json": "b7a9",
	"./es.estadoEnvio.json": "b647",
	"./es.expedientes.json": "5fae",
	"./es.impagos.json": "0af0",
	"./es.json": "a306",
	"./es.listaClientes.json": "8ad6",
	"./es.listaSegmentos.json": "ff5d",
	"./es.menu.json": "ae7a",
	"./es.miCuenta.json": "b48d",
	"./es.misconsultas.json": "9a5b",
	"./es.operacion.json": "e7f3",
	"./es.paginasError.json": "b11e",
	"./es.pagos.json": "7138",
	"./es.portalGranCliente.json": "caa5",
	"./es.producto.json": "2b6e",
	"./es.promocion.json": "4eb0",
	"./es.reclamacion.json": "b724",
	"./es.usuarios.json": "bd0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";